module.exports = __webpack_public_path__ + "img/linkedin.3d76e2de.svg";